module.exports = __webpack_public_path__ + "static/media/bg-gradient-v2-sm.defffb7c.svg";